import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import UiMeet3dMenu from "./UiMeet3dMenu";
import UiMeet3dHeader from "./UiMeet3dHeader";
import UiMeet3dMobileMenu from "~/modules/UiMeet3d/components/UiMeet3dMobileMenu";

function UiMeet3dLayoutWrapper(WrappedComponent, active = "") {
  @observer
  class UiMeet3dLayout extends Component {
    render() {
      return (
        <div id="tourLayoutWrapper" className="primary-container">
          <UiMeet3dHeader active={active} />
          <div className="tour-layout-edit-container">
            <div className="tour-layout-mobile-menu">
              <UiMeet3dMobileMenu active={active} />
            </div>
            <div className="tour-layout-sidebar-container">
              <UiMeet3dMenu active={active} />
            </div>
            <div className="tour-layout-content-container">
              <WrappedComponent {...this.props} />
            </div>
          </div>
        </div>
      );
    }
  }

  UiMeet3dLayout.propTypes = {
    t: PropTypes.func.isRequired,
  };

  return UiMeet3dLayout;
}

export default UiMeet3dLayoutWrapper;
